import React, { lazy, memo, Suspense } from 'react';

const CopilotSidebarTrigger = lazy(() => import('./index'));

const LazyCopilotSidebarTrigger = memo(
    ({ fallback = null, hasCopilotBar = false, hasCopilotSidebar = true }) => {
        if (!hasCopilotBar && !hasCopilotSidebar) return null;

        return (
            <Suspense fallback={fallback}>
                <CopilotSidebarTrigger
                    hasCopilotBar={hasCopilotBar}
                    hasCopilotSidebar={hasCopilotSidebar}
                />
            </Suspense>
        );
    },
);

LazyCopilotSidebarTrigger.displayName = 'LazyCopilotSidebarTrigger';

export default LazyCopilotSidebarTrigger;
